var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRightArrowGreenCircle = function SvgRightArrowGreenCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.077a.75.75 0 0 0 0 1.5v-1.5zm17.066 1.5a.75.75 0 0 0 0-1.5v1.5zm-17.066 0h17.066v-1.5H15v1.5z",
    fill: "#8CCE65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.731 31.758a.75.75 0 1 1-1.06-1.061l1.06 1.06zm5.87-6.93.53-.53a.75.75 0 0 1 0 1.06l-.53-.53zm-6.93-5.87a.75.75 0 0 1 1.06-1.06l-1.06 1.06zm0 11.739 6.4-6.4 1.06 1.06-6.4 6.4-1.06-1.06zm6.4-5.34-6.4-6.399 1.06-1.06 6.4 6.4-1.06 1.06z",
    fill: "#8CCE65"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.25,
    stroke: "#8CCE65",
    strokeWidth: 1.5
  })));
};

export default SvgRightArrowGreenCircle;